import { useMemo } from 'react';
import { useParams, type Params } from 'react-router-dom';

/** IMPORTANT NOTE: This does not currently support optional params */

function parsePathToParams(path: string, url: string) {
  // Create a regex pattern from the path
  const pathPattern = path
    .replace(/:[^\s/]+/g, '([^/]+)') // Replace named params with regex groups
    .replace(/\//g, '\\/'); // Escape slashes for regex

  const regex = new RegExp(`^${pathPattern}`); // Create a regex to match the URL
  const match = url.match(regex); // Match the URL against the regex

  if (!match) {
    return {};
  }

  const paramNames = (path.match(/:([^\s/]+)/g) || []).map((param) =>
    param.substring(1)
  ); // Extract parameter names

  const params: Record<string, string | undefined> = {};

  // Map the matched values to parameter names
  paramNames.forEach((name, index) => {
    params[name] = match[index + 1]; // match[0] is the full match, so we skip it
  });

  return params;
}

export function useSubRouteParams(path: string): Params {
  const { '*': url } = useParams();

  return useMemo(() => (url ? parsePathToParams(path, url) : {}), [path, url]);
}
